interface ConfigType {
    env: string;
    apiUrl: string;
}

// Targets for value injection via envsubst at publish time.
// Each value is a shell variable placeholder that CI replaces before the
// artifact is uploaded to S3. Build-time VITE_* vars take precedence when set.
const liveConfig: Record<string, string> = {
    ENVIRONMENT: "$CI_ENVIRONMENT_NAME",
    API_URL: "$TF_OUT_api_url",
};

const getConfigValue = (name: string): string | undefined => {
    const key = `VITE_${name}` as const;
    const fromEnv = (import.meta.env as Record<string, string | undefined>)[key];
    if (fromEnv && fromEnv.trim()) return fromEnv;

    // liveConfig placeholders are only meaningful after CI envsubst.
    // When running local, we never run envsubst, so don't let raw placeholders leak through.
    if (import.meta.env.DEV) return undefined;

    const liveVal = liveConfig[name];
    if (!liveVal || /^\$[A-Z_][A-Z0-9_]*$/.test(liveVal)) return undefined;
    return liveVal;
};

export const config: ConfigType = {
    env: getConfigValue("ENVIRONMENT") || "local",
    apiUrl: getConfigValue("API_URL") || "http://localhost:5000",
};
